import React from "react";
import Container from "react-bootstrap/Container";
import Pagination from "@components/Pagination";
import { Config } from "utils/Config";

import MediaCardSection from "./MediaCardSection";

export default function RenderProductCollection(props) {
	const { productCollection, currentPage, totalPages, sectionData = {} } = props.data;
	const contents = props.contents?.fields?.components || [];
	// const sectionHash = sectionData?.fields?.hashLink;

	if (!productCollection?.items?.length)
		return (
			<Container>
				<h2>
					<>Sorry, there are no items found in this Product Collection</>
				</h2>
			</Container>
		);

	return (
		<>
			<MediaCardSection
				data={{
					fields: { ...sectionData.fields, contents, isContainer: "md", mediaCards: productCollection.items },
				}}
			/>

			{!isNaN(totalPages) && totalPages > 1 && <Pagination totalPages={totalPages} currentPage={currentPage} />}
		</>
	);
}
